import { useState } from "react";

const FilterButton = ({ text, checked = false, onClick }) => {
  const [hover, setHover] = useState(false);
  
  // Inverted styling when checked: white background, white text, no border
  const borderColor = checked 
    ? "none"
    : (hover ? "#ffffff88" : "#ffffff44");
  const textColor = checked
    ? "#ffffff"
    : (hover ? "#ffffffaa" : "#ffffff66");
  const backgroundColor = checked
    ? (hover ? "#ffffff33" : "#ffffff22")
    : "transparent";
  
  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onClick={() => onClick()}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0px 10px",
        border: checked ? "none" : `1px solid ${borderColor}`,
        borderRadius: 4,
        fontSize: "9px",
        color: textColor,
        background: backgroundColor,
        userSelect: "none",
        fontWeight: "700",
        cursor: "pointer",
        boxSizing: "border-box",
        lineHeight: "1.1",
        height: "20px",
      }}
    >
      {text}
    </div>
  );
};

export default FilterButton;

